package one.healthium.profile.ui.weight_history

import androidx.compose.ui.util.fastForEach
import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.TimeZone
import kotlinx.datetime.format
import kotlinx.datetime.format.MonthNames
import kotlinx.datetime.toLocalDateTime
import one.healthium.profile.ui.weight.WeightHistoryUiModel

internal data class WeightHistoryUiState(
    val loading: Boolean = false,
    val weightHistory: List<WeightHistoryUiModel>? = null,
    val isMetric: Boolean = false,
    val deleteInProgress: Set<String> = emptySet(),
) {
    val uiData: List<Any>? = weightHistory?.let {
        var latestMonth: String? = null
        buildList {
            weightHistory
                .sortedByDescending { it.date }
                .filterNot { it.id in deleteInProgress }
                .fastForEach { weightHistoryUiModel ->
                    val month = weightHistoryUiModel.date.toLocalDateTime(TimeZone.currentSystemDefault()).format(dateFormatMonth)
                    if (latestMonth != month) {
                        add(month)
                    }
                    latestMonth = month

                    add(weightHistoryUiModel)
                }
        }
    }
}

private val dateFormatMonth = LocalDateTime.Format {
    monthName(MonthNames.ENGLISH_FULL)
}
